import React, { useState, useEffect, useRef, useMemo } from 'react';
import nimg from '../img/NIMGN.png';
import nimg1 from '../img/NIMG1N.svg';
import nimg2 from '../img/BMLogo.png';
import l4img from '../img/L4.png';
import l3img from '../img/L3.png';
import lpnm1 from '../img/LPNM2.png';
import lp4nme from '../img/LP4NME.png';
import lp4nmes from '../img/LP4NMES.png';
import { ClaimFormSendEmails } from '../emailService';

const MAKE_WEBHOOK_URL = 'https://hook.eu2.make.com/7pynsgbax6gyoslgr58hqa67ag816wm5';
const META_PIXEL_ID = '1273735194580393';

  // --- RAW CSS FOR MEDIA QUERIES & PSEUDO ELEMENTS ---
const mediaQueriesAndPseudo = `
  * { box-sizing: border-box; }
  @keyframes crSpin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }
  /* Pseudo-classes replacements */
  .btn-primary:hover { background-color: #b93a2b !important; }
  .btn-previous:hover { background-color: #b93a2b !important; }
  .btn-submit:hover { background-color: #b93a2b !important; }
  .btn-back:hover { color: #D14836 !important; }
  .form-input:focus { border-color: #1a237e !important; background: #fff !important; }
  /* Enforce hero typography */
  .lp-headline {
      color: #0A1F8F !important;
      font-family: "Rethink Sans", sans-serif !important;
      font-size: 50px !important;
      font-weight: 700 !important;
      line-height: 60px !important;
      text-align: center !important;
  }
  .lp-subheadline {
      color: #D14836 !important;
      font-family: "Rethink Sans", sans-serif !important;
      font-size: 20px !important;
      font-weight: 600 !important;
      line-height: normal !important;
      text-align: center !important;
  }
  .lp-question {
      color: #0A1F8F !important;
      font-family: "Rethink Sans", sans-serif !important;
      font-size: 28px !important;
      font-weight: 700 !important;
      line-height: normal !important;
      text-align: center !important;
  }
  .lp-subtext {
      color: #0A1F8F !important;
      font-family: "Rethink Sans", sans-serif !important;
      font-size: 16px !important;
      font-weight: 600 !important;
      line-height: normal !important;
      text-transform: capitalize !important;
      text-align: center !important;
  }
  .lp-graytext {
      color: #0A1F8F !important;
      font-family: "Rethink Sans", sans-serif !important;
      font-size: 15px !important;
      font-weight: 400 !important;
      line-height: normal !important;
      letter-spacing: -0.2px !important;
      text-transform: capitalize !important;
      text-align: center !important;
  }
  .lp-mobile-headline {
      color: #0A1F8F !important;
      font-family: "Rethink Sans", sans-serif !important;
      font-size: 32px !important;
      font-weight: 700 !important;
      line-height: 40px !important;
      text-align: center !important;
  }
  .lp-mobile-subtext {
      color: #D14836 !important;
      font-family: "Rethink Sans", sans-serif !important;
      font-size: 20px !important;
      font-weight: 600 !important;
      line-height: normal !important;
      text-align: center !important;
  }
  .lp-mobile-graytext {
      color: #0A1F8F !important;
      font-family: "Rethink Sans", sans-serif !important;
      font-size: 15px !important;
      font-weight: 400 !important;
      line-height: normal !important;
      letter-spacing: -0.2px !important;
      text-transform: capitalize !important;
      text-align: center !important;
  }
  
  /* Radio Styling Logic */
  .radio-option input[type="radio"] { display: none; }
  .radio-option label {
      display: flex; align-items: center; padding: 12px 15px;
      background: #fff; border: 1px solid #e0e0e0; border-radius: 6px;
      cursor: pointer; font-size: 16.11px; color: #162766;
      transition: all 0.2s; font-weight: 500; width: 100%;
      box-sizing: border-box;
      position: relative;
      font-family: "Rethink Sans", sans-serif;
  }
  .radio-option label::before {
      content: ''; width: 18px; height: 18px; border: 2px solid #b0bec5;
      border-radius: 50%; margin-right: 12px; background: white; transition: all 0.2s; flex-shrink: 0;
  }
  .radio-option input[type="radio"]:checked + label {
      background-color: #fff; color: #0A1F8F; border-color: #0A1F8F;
      box-shadow: 0 2px 8px rgba(10, 31, 143, 0.1);
  }
  .radio-option input[type="radio"]:checked + label::before {
      background-color: #0A1F8F; 
      border: 3px solid white;
      box-shadow: 0 0 0 1px #0A1F8F, 0 0 4px rgba(255, 255, 255, 0.8);
  }

  /* Custom Option Hover & Select */
  .custom-option {
      position: relative; display: flex; align-items: center; padding: 14px 20px;
      font-size: 16.11px; color: #162766; cursor: pointer; transition: background 0.2s;
      border-bottom: 1px solid #f5f5f5;
      font-family: "Rethink Sans", sans-serif;
      font-weight: 500;
  }
  .custom-option:hover { background-color: #f5f7fa; }
  .custom-option:last-child { border-bottom: none; }
  .custom-option .radio-circle {
      width: 18px; height: 18px; border: 2px solid #b0bec5; border-radius: 50%;
      margin-right: 15px; position: relative; flex-shrink: 0;
  }
  .custom-option.selected { background-color: #e8eaf6; color: #1a237e; font-weight: 500; }
  .custom-option.selected .radio-circle { border-color: #1a237e; border-width: 2px; }
  .custom-option.selected .radio-circle::after {
      content: ''; position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);
      width: 10px; height: 10px; background-color: #1a237e; border-radius: 50%;
  }

  /* --- RESPONSIVE MEDIA QUERIES --- */
  @media (max-width: 992px) {
      .container { flex-direction: column; width: 100%; gap: 20px; }
      .left-panel, .right-panel { width: 100% !important; max-width: 650px; margin: 0 auto; }
  }
  @media (max-width: 600px) {
      .main-body-wrapper { padding: 0 !important; overflow: visible !important; }
      .container { gap: 15px; overflow: visible !important; }
      .left-panel, .right-panel { padding: 0 !important; }
      h1 { font-size: 2.5rem !important; }
      .radio-options { gap: 10px !important; } 
      /* Remove remaining mobile left/right padding inside options/inputs */
      .radio-option label { padding: 10px 12px !important; font-size: 14px !important; }
      .custom-option { padding: 10px 15px !important; }
      .custom-select-trigger { padding-left: 0 !important; padding-right: 0 !important; }
      /* Add horizontal padding around custom dropdown options container on mobile */
      .custom-options { padding: 0 12px; }
      .success-card { padding: 30px 20px !important; }
      /* Enable scrolling on mobile form card */
      .mobile-form-card-scrollable {
          -webkit-overflow-scrolling: touch !important;
          touch-action: pan-y !important;
          overscroll-behavior: contain !important;
          will-change: scroll-position !important;
      }
      /* Prevent button overflow on mobile */
      button.btn-primary {
          max-width: 100% !important;
          box-sizing: border-box !important;
          overflow: hidden !important;
      }
      /* Prevent body scroll on mobile when form is open */
      body.mobile-form-open {
          overflow: hidden !important;
          position: fixed !important;
          width: 100% !important;
      }
  }
  @media (max-width: 400px) {
      .radio-option label { padding: 10px; font-size: 0.85rem; }
      .form-label { font-size: 0.9rem; }
  }
`;

const FormWrapper = ({ isMobile, mobileFormCardStyle, children }) => (
  isMobile ? <div className="mobile-form-card-scrollable" style={mobileFormCardStyle}>{children}</div> : <>{children}</>
);

const GlobalStyles = React.memo(() => (
  <style>{mediaQueriesAndPseudo}</style>
));

const ClaimForm3= () => {
  // --- STATE MANAGEMENT ---
  const [showLandingPage, setShowLandingPage] = useState(true); // Start with landing page
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [isBtnHovered, setIsBtnHovered] = useState(false);
  const [step, setStep] = useState(1);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [period, setPeriod] = useState('');
  const [isEligible, setIsEligible] = useState(null); // null: not checked, true: eligible, false: not eligible
  const [showEligibilityCheck, setShowEligibilityCheck] = useState(false);
  const [showEligibilitySuccess, setShowEligibilitySuccess] = useState(false);
  
  // Form State
  const [formData, setFormData] = useState({
    involved: '',
    injured: '',
    fault: '',
    attorney: '',
    name: '',
    phone: '',
    email: '',
    terms: false
  });

  const [crmSubmissionId, setCrmSubmissionId] = useState(null);
  const [hasPhoneSubmitted, setHasPhoneSubmitted] = useState(false);
  const [lastEmailUpdate, setLastEmailUpdate] = useState('');
  const [lastFetchedSubmission, setLastFetchedSubmission] = useState(null);

  // Validation errors state
  const [errors, setErrors] = useState({
    name: '',
    phone: '',
    email: ''
  });
  
  // Ref to prevent multiple simultaneous API calls
  const isProcessingPhoneRef = useRef(false);

  const dropdownRef = useRef(null);
  
  // Ref to track if pixel has been fired for thank you page
  const thankYouPagePixelFired = useRef(false);

  // --- Meta Pixel Helpers ---

  /**
   * Format email for Meta Pixel advanced matching
   * Requirements: Lowercase unhashed (Meta will hash automatically)
   */
  const formatEmailForMeta = (email) => {
    if (!email) return null;
    return email.trim().toLowerCase();
  };

  /**
   * Format phone number for Meta Pixel advanced matching
   * Requirements: Digits only including country code and area code
   * Example: 16505554444 (1 for US country code + 10 digits)
   */
  const formatPhoneForMeta = (phone) => {
    if (!phone) return null;
    // Remove all non-digits
    const digits = phone.replace(/\D/g, '');
    // If 10 digits, assume US and add country code "1"
    if (digits.length === 10) {
      return `1${digits}`;
    }
    // If already has country code, return as is
    if (digits.length >= 10) {
      return digits;
    }
    return null;
  };

  /**
   * Parse full name into first and last name
   * Returns: { firstName: string, lastName: string }
   */
  const parseName = (fullName) => {
    if (!fullName) return { firstName: null, lastName: null };
    const trimmed = fullName.trim();
    const parts = trimmed.split(/\s+/);
    if (parts.length === 1) {
      return { firstName: parts[0].toLowerCase(), lastName: null };
    }
    const firstName = parts[0].toLowerCase();
    const lastName = parts.slice(1).join(' ').toLowerCase();
    return { firstName, lastName };
  };

  /**
   * Track Complete Registration event
   * Called when user clicks "Start free case review" / "Continue" / "Start Your Claim" button
   * Uses trackCustom for non-standard event name "Complete Registration"
   */
  const trackMetaPixelCompleteRegistration = () => {
    if (typeof window === 'undefined') {
      console.warn('🔴 Meta Pixel (CF3): Window not available');
      return;
    }

    const pixelKey = META_PIXEL_ID;

    // Ensure pixel is initialized before tracking
    if (!window._metaPixelInitialized || !window._metaPixelInitialized[pixelKey]) {
      if (!window.fbq) {
        console.warn('🔴 Meta Pixel (CF3): fbq not available yet, will retry for pixel', META_PIXEL_ID);
        setTimeout(() => {
          if (window.fbq) {
            if (!window._metaPixelInitialized) window._metaPixelInitialized = {};
            window.fbq('init', pixelKey);
            window._metaPixelInitialized[pixelKey] = true;
            console.log('🟢 Meta Pixel (CF3): Retrying Complete Registration event for pixel', META_PIXEL_ID);
            if (window.fbq.loaded) {
              console.log('📡 API CALL: Complete Registration - Sending to Facebook Pixel (retry)', META_PIXEL_ID);
              console.log('📡 API CALL URL: https://www.facebook.com/tr/?id=' + META_PIXEL_ID + '&ev=Complete%20Registration');
              window.fbq('trackCustom', 'Complete Registration');
              console.log('✅ Meta Pixel (CF3): Complete Registration event tracked successfully (retry) for pixel', META_PIXEL_ID);
            }
          }
        }, 100);
        return;
      }
      console.log('🔵 Meta Pixel (CF3): Initializing pixel before Complete Registration for pixel', META_PIXEL_ID);
      window.fbq('init', pixelKey);
      if (!window._metaPixelInitialized) window._metaPixelInitialized = {};
      window._metaPixelInitialized[pixelKey] = true;
      console.log('✅ Meta Pixel (CF3): Pixel initialized for Complete Registration', META_PIXEL_ID);
    }

    if (!window.fbq) {
      console.warn('🔴 Meta Pixel (CF3): fbq not available yet');
      return;
    }

    // Wait for fbq to be loaded if not ready yet
    if (!window.fbq.loaded) {
      console.warn('⏳ Meta Pixel (CF3): fbq not loaded yet, waiting...');
      let retries = 0;
      const maxRetries = 20;
      const checkLoaded = setInterval(() => {
        retries++;
        if (window.fbq && window.fbq.loaded) {
          clearInterval(checkLoaded);
          console.log('🟢 Meta Pixel (CF3): Tracking Complete Registration event for pixel', META_PIXEL_ID);
          console.log('📡 API CALL: Complete Registration - Sending to Facebook Pixel', META_PIXEL_ID);
          console.log('📡 API CALL URL: https://www.facebook.com/tr/?id=' + META_PIXEL_ID + '&ev=Complete%20Registration');
          window.fbq('trackCustom', 'Complete Registration');
          console.log('✅ Meta Pixel (CF3): Complete Registration event tracked successfully for pixel', META_PIXEL_ID);
        } else if (retries >= maxRetries) {
          clearInterval(checkLoaded);
          console.error('❌ Meta Pixel (CF3): fbq failed to load after retries, tracking anyway');
          if (window.fbq) {
            console.log('📡 API CALL: Complete Registration - Sending to Facebook Pixel (retry)', META_PIXEL_ID);
            console.log('📡 API CALL URL: https://www.facebook.com/tr/?id=' + META_PIXEL_ID + '&ev=Complete%20Registration');
            window.fbq('trackCustom', 'Complete Registration');
          }
        }
      }, 100);
      return;
    }

    console.log('🟢 Meta Pixel (CF3): Tracking Complete Registration event for pixel', META_PIXEL_ID);
    console.log('📡 API CALL: Complete Registration - Sending to Facebook Pixel', META_PIXEL_ID);
    console.log('📡 API CALL URL: https://www.facebook.com/tr/?id=' + META_PIXEL_ID + '&ev=Complete%20Registration');
    // Use trackCustom for non-standard event name "Complete Registration"
    window.fbq('trackCustom', 'Complete Registration');
    console.log('✅ Meta Pixel (CF3): Complete Registration event tracked successfully for pixel', META_PIXEL_ID);
  };

  /**
   * Track Lead event with advanced matching data
   * Uses trackSingle to pass advanced matching without re-initializing pixel
   */
  const trackMetaPixelLead = (userData) => {
    if (typeof window === 'undefined') {
      console.warn('🔴 Meta Pixel (CF3): Window not available for Lead');
      return;
    }

    const pixelKey = META_PIXEL_ID;

    // Ensure pixel is initialized before tracking
    if (!window._metaPixelInitialized || !window._metaPixelInitialized[pixelKey]) {
      if (!window.fbq) {
        console.warn('🔴 Meta Pixel (CF3): fbq not available for Lead');
        return;
      }
      if (!window._metaPixelInitialized) window._metaPixelInitialized = {};
      window.fbq('init', pixelKey);
      window._metaPixelInitialized[pixelKey] = true;
      console.log('✅ Meta Pixel (CF3): Pixel initialized for Lead', META_PIXEL_ID);
    }

    if (!window.fbq) {
      console.warn('🔴 Meta Pixel (CF3): fbq not available for Lead');
      return;
    }

    // Helper function to actually track the Lead event
    const trackLeadEvent = () => {
      const advancedMatching = {};
      
      // Email: lowercase unhashed (Meta will hash automatically)
      if (userData.email) {
        const formattedEmail = formatEmailForMeta(userData.email);
        if (formattedEmail) {
          advancedMatching.em = formattedEmail;
        }
      }

      // Phone: digits only with country code
      if (userData.phone) {
        const formattedPhone = formatPhoneForMeta(userData.phone);
        if (formattedPhone) {
          advancedMatching.ph = formattedPhone;
        }
      }

      // First Name: lowercase letters
      if (userData.firstName) {
        advancedMatching.fn = userData.firstName.toLowerCase();
      }

      // Last Name: lowercase letters
      if (userData.lastName) {
        advancedMatching.ln = userData.lastName.toLowerCase();
      }

      // Track Lead event with advanced matching data
      // Use trackSingle to pass advanced matching without re-initializing the pixel
      if (Object.keys(advancedMatching).length > 0) {
        console.log('🟢 Meta Pixel (CF3): Tracking Lead event with advanced matching for pixel', META_PIXEL_ID, advancedMatching);
        console.log('📡 API CALL: Lead Event (Submit) - Sending to Facebook Pixel with advanced matching', META_PIXEL_ID);
        console.log('📡 API CALL URL: https://www.facebook.com/tr/?id=' + META_PIXEL_ID + '&ev=Lead');
        console.log('📡 API CALL DATA:', advancedMatching);
        window.fbq('trackSingle', META_PIXEL_ID, 'Lead', {}, advancedMatching);
        console.log('✅ Meta Pixel (CF3): Lead event tracked with advanced matching for pixel', META_PIXEL_ID);
      } else {
        console.log('🟢 Meta Pixel (CF3): Tracking Lead event (no advanced matching) for pixel', META_PIXEL_ID);
        console.log('📡 API CALL: Lead Event (Submit) - Sending to Facebook Pixel', META_PIXEL_ID);
        console.log('📡 API CALL URL: https://www.facebook.com/tr/?id=' + META_PIXEL_ID + '&ev=Lead');
        window.fbq('track', 'Lead');
        console.log('✅ Meta Pixel (CF3): Lead event tracked successfully for pixel', META_PIXEL_ID);
      }
    };

    // Wait for fbq to be loaded if not ready yet
    if (!window.fbq.loaded) {
      console.warn('⏳ Meta Pixel (CF3): fbq not loaded yet for Lead, waiting...');
      let retries = 0;
      const maxRetries = 20;
      const checkLoaded = setInterval(() => {
        retries++;
        if (window.fbq && window.fbq.loaded) {
          clearInterval(checkLoaded);
          trackLeadEvent();
        } else if (retries >= maxRetries) {
          clearInterval(checkLoaded);
          console.error('❌ Meta Pixel (CF3): fbq failed to load after retries, tracking anyway');
          if (window.fbq) {
            trackLeadEvent();
          }
        }
      }, 100);
      return;
    }

    trackLeadEvent();
  };

  // Initialize Meta Pixel on component mount (PageView)
  useEffect(() => {
    if (typeof window === 'undefined') return;

    // Global flag to prevent multiple initializations and PageView tracking
    if (typeof window._metaPixelInitialized !== 'object') {
      window._metaPixelInitialized = {};
    }
    if (typeof window._metaPixelPageViewTracked !== 'object') {
      window._metaPixelPageViewTracked = {};
    }

    const pixelKey = META_PIXEL_ID;
    // Track PageView **per route** so each stepper form / route gets its own PageView
    const currentPath = typeof window !== 'undefined' ? window.location.pathname || '' : '';
    const pageKey = `${pixelKey}:${currentPath}`;
    let pageViewTracked = window._metaPixelPageViewTracked[pageKey] || false;

    // Function to initialize and track PageView
    const initAndTrack = () => {
      if (window.fbq && !pageViewTracked) {
        try {
          // Only init if not already initialized for this pixel ID
          if (!window._metaPixelInitialized[pixelKey]) {
            console.log('🔵 Meta Pixel (CF3): Initializing pixel', META_PIXEL_ID);
            window.fbq('init', META_PIXEL_ID);
            window._metaPixelInitialized[pixelKey] = true;
            console.log('✅ Meta Pixel (CF3): Pixel initialized successfully', META_PIXEL_ID);
          }
          // Only track PageView once per route (React SPA "page")
          if (!window._metaPixelPageViewTracked[pageKey]) {
            console.log('🔵 Meta Pixel (CF3): Tracking PageView for pixel', META_PIXEL_ID, 'on path', currentPath);
            window.fbq('track', 'PageView');
            window._metaPixelPageViewTracked[pageKey] = true;
            pageViewTracked = true;
            console.log('✅ Meta Pixel (CF3): PageView tracked successfully for pixel', META_PIXEL_ID, 'on path', currentPath);
          }
        } catch (error) {
          console.error('❌ Meta Pixel (CF3) tracking error:', error);
        }
      }
    };

    // Function to wait for fbq to be ready with retry
    const waitForFbq = (maxRetries = 10, retryDelay = 100) => {
      let retries = 0;
      const checkFbq = () => {
        if (window.fbq && window.fbq.loaded) {
          initAndTrack();
        } else if (retries < maxRetries) {
          retries++;
          setTimeout(checkFbq, retryDelay);
        } else {
          // Last attempt - try anyway if fbq exists
          if (window.fbq) {
            initAndTrack();
          }
        }
      };
      checkFbq();
    };

    // Check if already initialized and PageView tracked for this route - skip if so
    if (window._metaPixelInitialized[pixelKey] && window._metaPixelPageViewTracked[pageKey]) {
      return; // Already initialized and tracked for this "page", no need to do anything
    }

    // Check if Meta Pixel script is already in the DOM
    const existingScript = document.querySelector('script[src*="fbevents.js"]');
    
    if (existingScript) {
      console.log('📜 Meta Pixel (CF3): Script already exists in DOM');
      // Script already exists
      if (window.fbq && window.fbq.loaded) {
        // Script is loaded, initialize immediately
        console.log('✅ Meta Pixel (CF3): Script loaded, initializing immediately for pixel', META_PIXEL_ID);
        initAndTrack();
      } else {
        // Wait for script to be ready
        console.log('⏳ Meta Pixel (CF3): Script exists but not loaded yet, waiting...');
        waitForFbq();
      }
    } else {
      // Script doesn't exist, load it
      console.log('📥 Meta Pixel (CF3): Loading script for pixel', META_PIXEL_ID);
      (function(f,b,e,v,n,t,s) {
        if(f.fbq) {
          console.log('⚠️ Meta Pixel (CF3): fbq already exists, skipping script load');
          return;
        }
        console.log('📦 Meta Pixel (CF3): Initializing fbq function');
        n=f.fbq=function(){
          n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)
        };
        if(!f._fbq)f._fbq=n;
        n.push=n;
        n.loaded=!0;
        n.version='2.0';
        n.queue=[];
        t=b.createElement(e);
        t.async=!0;
        t.src=v;
        t.onload = function() {
          console.log('✅ Meta Pixel (CF3): Script loaded successfully for pixel', META_PIXEL_ID);
          // Script loaded, wait a bit then initialize and track
          setTimeout(() => {
            waitForFbq();
          }, 50);
        };
        t.onerror = function() {
          console.error('❌ Meta Pixel (CF3): Script failed to load for pixel', META_PIXEL_ID);
        };
        s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s);
      })(window, document,'script','https://connect.facebook.net/en_US/fbevents.js');
    }
  }, []);

  // Track Meta Pixel PageView and Lead when thank you page appears
  useEffect(() => {
    if (isSubmitted && typeof window !== 'undefined' && !thankYouPagePixelFired.current) {
      // Use a small delay to ensure the thank you page is fully rendered
      const trackPixel = () => {
        if (!window.fbq) {
          // Retry if fbq is not ready yet (max 10 retries = 1 second)
          if (trackPixel.retries === undefined) trackPixel.retries = 0;
          if (trackPixel.retries < 10) {
            trackPixel.retries++;
            setTimeout(trackPixel, 100);
            return;
          } else {
            console.warn('Meta Pixel: fbq not available after retries');
            return;
          }
        }

        // Check if pixel is initialized - if not, wait a bit more
        if (!window._metaPixelInitialized || !window._metaPixelInitialized[META_PIXEL_ID]) {
          if (trackPixel.initRetries === undefined) trackPixel.initRetries = 0;
          if (trackPixel.initRetries < 5) {
            trackPixel.initRetries++;
            setTimeout(trackPixel, 200);
            return;
          }
        }

        try {
          // Mark as fired to prevent duplicate tracking
          thankYouPagePixelFired.current = true;

          // Ensure pixel is initialized before tracking
          if (!window._metaPixelInitialized || !window._metaPixelInitialized[META_PIXEL_ID]) {
            window.fbq('init', META_PIXEL_ID);
            if (!window._metaPixelInitialized) window._metaPixelInitialized = {};
            window._metaPixelInitialized[META_PIXEL_ID] = true;
          }
          
          // Track Lead event on thank you page (as per Meta Pixel Lead code)
          if (formData.name && (formData.email || formData.phone)) {
            const nameParts = parseName(formData.name);
            console.log('🎯 Meta Pixel: Tracking Lead event on thank you page with advanced matching');
            trackMetaPixelLead({
              email: formData.email,
              phone: formData.phone,
              firstName: nameParts.firstName,
              lastName: nameParts.lastName
            });
          } else {
            // Track Lead without advanced matching if user data not available
            console.log('🎯 Meta Pixel: Tracking Lead event on thank you page (no advanced matching)');
            window.fbq('track', 'Lead');
          }
        } catch (error) {
          console.error('Meta Pixel tracking error on thank you page:', error);
          // Reset flag on error so it can retry
          thankYouPagePixelFired.current = false;
        }
      };

      // Small delay to ensure DOM is ready and thank you page is visible
      setTimeout(trackPixel, 300);
    } else if (!isSubmitted) {
      // Reset the flag when form is reset (if user goes back)
      thankYouPagePixelFired.current = false;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSubmitted]);

  // Google Ads "Page view" conversion – fire ONLY on ClaimReview3 mount
  useEffect(() => {
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('event', 'conversion', {
        'send_to': 'AW-17811188696/6KB3CMbRhuIbENjXhK1C',
      });
    }
  }, []);

  // Handle window resize for landing page responsiveness
  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const isMobile = windowWidth < 900;

  // Calculate scale factors for responsive text sizing while keeping position constant
  const getTextScale = (baseWidth = 1920) => {
    // For mobile, use a higher minimum scale to make text larger
    const minScale = isMobile ? 0.9 : 0.6;
    const scale = Math.min(Math.max(windowWidth / baseWidth, minScale), 1.2);
    return scale;
  };

  const headlineScale = getTextScale(1920);
  const subtextScale = getTextScale(1920);
  const bottomTextScale = getTextScale(1920);

  const getTrustedFormDataFromDOM = () => {
    if (typeof document === 'undefined') return {};

    const certField = document.querySelector('[name="xxTrustedFormCertUrl"]');
    const pingField = document.querySelector('[name="xxTrustedFormPingUrl"]');
    const tokenField = document.querySelector('[name="xxTrustedFormCertToken"]');

    return {
      xxTrustedFormCertUrl: certField?.value || '',
      xxTrustedFormPingUrl: pingField?.value || '',
      xxTrustedFormCertToken: tokenField?.value || '',
    };
  };

  const getIPAddress = async () => {
    try {
      const response = await fetch('https://api.ipify.org?format=json');
      const data = await response.json();
      return data?.ip || '';
    } catch (error) {
      console.error('Failed to get IP address:', error);
      return '';
    }
  };

  const sendToMakeWebhook = async ({ name, email, phone, trustedFormCertUrl, ipAddress }) => {
    try {
      const res = await fetch(MAKE_WEBHOOK_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name,
          email,
          phone,
          trustedFormCertUrl,
          ipAddress,
        }),
      });

      if (!res.ok) {
        // Don't block form submission; just log for debugging.
        console.error('Make webhook failed:', res.status, res.statusText);
      }
    } catch (err) {
      // Don't block form submission; just log for debugging.
      console.error('Make webhook error:', err);
    }
  };

  const sendToCRMBackend = async (formData, { method = 'POST', id = null } = {}) => {
    try {
      const payload = {
        countryName: 'USA',
        brandName: 'Claim4Accidents',
        websiteName: window.location.hostname || 'claim4accidents.com',
        formname: 'ClaimReview4',
        data: formData
      };

      const url = id
        ? `https://crm-internal-backend-ayb9fqawg8b6bjen.canadacentral-01.azurewebsites.net/api/submitformdata/${id}`
        : 'https://crm-internal-backend-ayb9fqawg8b6bjen.canadacentral-01.azurewebsites.net/api/submitformdata';

      console.log(`[CRM-CR4] Making ${method} request to:`, url, { id, hasId: !!id });

      const res = await fetch(url, {
        method,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });

      if (!res.ok) {
        console.error(`[CRM-CR4] ${method} request failed:`, res.status, res.statusText);
        const errorText = await res.text().catch(() => '');
        console.error('[CRM-CR4] Error response:', errorText);
        return null;
      }

      const json = await res.json().catch(() => ({}));
      console.log(`[CRM-CR4] ${method} request successful:`, json);
      return json;
    } catch (err) {
      console.error(`[CRM-CR4] ${method} request error:`, err);
      return null;
    }
  };

  // Check eligibility based on all answers
  const checkEligibility = () => {
    // Eligibility rules from spreadsheet:
    // 1. Were you involved? Yes = Eligible, No = Not eligible
    // 2. Were you injured? Yes = Eligible, No = Not eligible
    // 3. Were you legally at fault? Yes = Not eligible, No = Eligible
    // 4. Do you already have an attorney? Yes = Not eligible, No = Eligible
    // 5. When did the accident happen? All time periods = Eligible
    
    const eligible = 
      formData.involved === 'yes' &&  // Must be involved
      formData.injured === 'yes' &&   // Must be injured
      formData.fault === 'no' &&     // Must NOT be at fault
      formData.attorney === 'no' &&   // Must NOT have an attorney
      period !== '';                  // Time period must be selected (all are eligible)
    
    return eligible;
  };

  const fetchCrmSubmission = async (id) => {
    if (!id) {
      console.warn('[CRM-CR4] Cannot fetch: No ID provided');
      return null;
    }
    try {
      console.log('[CRM-CR4] Making GET call to fetch entry with ID:', id);
      const res = await fetch(`https://crm-internal-backend-ayb9fqawg8b6bjen.canadacentral-01.azurewebsites.net/api/submitformdata/id/${id}`);
      if (!res.ok) {
        console.error('[CRM-CR4] GET request failed:', res.status, res.statusText);
        return null;
      }
      const json = await res.json().catch(() => null);
      if (json?.data) {
        setLastFetchedSubmission(json.data);
        console.log('[CRM-CR4] GET successful! Entry data:', json.data);
      }
      return json?.data || null;
    } catch (err) {
      console.error('[CRM-CR4] GET request error:', err);
      return null;
    }
  };

  const triggerPhoneSubmission = async (digits) => {
    // Prevent multiple calls: check ref, state, and exact length
    if (isProcessingPhoneRef.current || hasPhoneSubmitted || !digits || digits.length !== 10) {
      return;
    }

    // Set processing flag immediately to prevent race conditions
    isProcessingPhoneRef.current = true;

    try {
      console.log('[CRM-CR4] Phone has 10 digits, making POST call to create entry...');

      const response = await sendToCRMBackend({
        name: formData.name,
        phone: digits,
        email: formData.email || '',
        involved: formData.involved,
        injured: formData.injured,
        fault: formData.fault,
        attorney: formData.attorney,
        period: period,
        tcpaConsent: false,
      }, { method: 'POST' });

      if (response?.id) {
        const uniqueId = response.id;
        console.log('[CRM-CR4] POST successful! Unique ID received:', uniqueId);

        setCrmSubmissionId(uniqueId);
        setHasPhoneSubmitted(true);

        console.log('[CRM-CR4] Fetching entry with GET call using unique ID:', uniqueId);
        const fetchedData = await fetchCrmSubmission(uniqueId);
        if (fetchedData) {
          console.log('[CRM-CR4] GET successful! Entry retrieved:', fetchedData);
        } else {
          console.warn('[CRM-CR4] GET failed - could not retrieve entry');
        }
      } else {
        console.error('[CRM-CR4] POST failed - no ID received in response:', response);
      }
    } finally {
      // Always reset the processing flag
      isProcessingPhoneRef.current = false;
    }
  };

  const triggerEmailUpdate = async (emailValue) => {
    const trimmed = emailValue.trim();
    if (!trimmed.toLowerCase().endsWith('.com')) return;
    if (trimmed === lastEmailUpdate) return;

    console.log('[CRM-CR4] Email ends with .com, checking for submission ID...');

    if (!crmSubmissionId && formData.phone.length === 10 && !hasPhoneSubmitted) {
      console.log('[CRM-CR4] No submission ID found, creating entry with phone first...');
      await triggerPhoneSubmission(formData.phone);
      await new Promise(resolve => setTimeout(resolve, 1000));
    }

    if (!crmSubmissionId) {
      console.warn('[CRM-CR4] Cannot update email: No submission ID available. Phone may not have been submitted yet.');
      return;
    }

    console.log('[CRM-CR4] Making PUT call to update email in entry with unique ID:', crmSubmissionId);

    const response = await sendToCRMBackend({
      name: formData.name,
      phone: formData.phone,
      email: trimmed,
      involved: formData.involved,
      injured: formData.injured,
      fault: formData.fault,
      attorney: formData.attorney,
      period: period,
      tcpaConsent: true,
    }, { method: 'PUT', id: crmSubmissionId });

    if (response) {
      setLastEmailUpdate(trimmed);
      console.log('[CRM-CR4] PUT successful! Email updated in entry ID:', crmSubmissionId);

      const updatedData = await fetchCrmSubmission(crmSubmissionId);
      if (updatedData) {
        console.log('[CRM-CR4] Verified updated entry:', updatedData);
      }
    } else {
      console.error('[CRM-CR4] PUT failed - email update unsuccessful');
    }
  };


  // --- HANDLERS ---
  const handleNext = () => {
    if (isMobile) {
      // Mobile navigation logic
      if (step === 1) {
        // Step 1: Validate first 3 questions
        if (!formData.involved || !formData.injured || !formData.fault) {
          alert('Please answer all questions before proceeding to the next step.');
          return;
        }
        setStep(2);
      } else if (step === 2) {
        // Step 2: Validate attorney and period
        if (!formData.attorney || !period) {
          alert('Please answer all questions before proceeding to the next step.');
          return;
        }
        
        // Track Google Ads Sign-Up conversion
        if (typeof window !== 'undefined' && window.gtag_report_conversion) {
          window.gtag_report_conversion();
        }
        
        // Check eligibility after step 2
        const eligible = checkEligibility();
        setIsEligible(eligible);
        
        if (eligible) {
          // Show eligibility success overlay (full screen)
          setShowEligibilitySuccess(true);
        } else {
          setShowEligibilityCheck(true);
        }
      }
    } else {
      // Desktop navigation logic
      // Validate all step 1 fields before proceeding
      if (!formData.involved || !formData.injured || !formData.fault || !formData.attorney || !period) {
        alert('Please fill in all fields before proceeding to the next step.');
        return;
      }
      
      // Track Google Ads Sign-Up conversion
      if (typeof window !== 'undefined' && window.gtag_report_conversion) {
        window.gtag_report_conversion();
      }
      
      // Check eligibility
      const eligible = checkEligibility();
      setIsEligible(eligible);
      
      if (eligible) {
        // Show eligibility success overlay (full screen)
        setShowEligibilitySuccess(true);
      } else {
        setShowEligibilityCheck(true);
      }
    }
  };

  const handlePrevious = () => {
    if (step === 1) {
      setShowLandingPage(true);
    } else if (step === 2) {
      setStep(1);
    } else if (step === 3) {
      setStep(2);
    }
  };

  const handleSubmit = async () => {
    // Validate all fields
    const nameError = validateName(formData.name);
    const phoneError = validatePhone(formData.phone);
    const emailError = validateEmail(formData.email);

    // Update errors state
    setErrors({
      name: nameError,
      phone: phoneError,
      email: emailError
    });

    // Check if there are any validation errors
    if (nameError || phoneError || emailError) {
      alert('Please correct the errors in the form before submitting.');
      return;
    }

    if (!formData.terms) {
      alert('Please accept the terms and conditions');
      return;
    }

    setIsSubmitting(true);

    try {
      const trustedFormData = getTrustedFormDataFromDOM();
      const ipAddress = await getIPAddress();

      await sendToMakeWebhook({
        name: formData.name,
        email: formData.email,
        phone: formData.phone,
        trustedFormCertUrl: trustedFormData.xxTrustedFormCertUrl || '',
        ipAddress,
      });

      // Check eligibility before submitting
      const eligible = checkEligibility();
      
      // Prepare email data
      const emailData = {
        name: formData.name,
        email: formData.email,
        phone: formData.phone,
        involved: formData.involved === 'yes' ? 'Yes' : formData.involved === 'no' ? 'No' : 'Not answered',
        injured: formData.injured === 'yes' ? 'Yes' : formData.injured === 'no' ? 'No' : 'Not answered',
        fault: formData.fault === 'yes' ? 'Yes' : formData.fault === 'no' ? 'No' : 'Not answered',
        attorney: formData.attorney === 'yes' ? 'Yes' : formData.attorney === 'no' ? 'No' : 'Not answered',
        period: period || 'Not specified',
        eligibility_status: eligible ? 'eligible' : 'not-eligible',
        eligibility_status_text: eligible ? 'Eligible' : 'Not Eligible',
      };

      // Send emails sequentially: admin first, then user if admin succeeds
      const result = await ClaimFormSendEmails(emailData, trustedFormData);

      if (result.success) {
        // Send data to CRM backend after EmailJS is successfully triggered
        await sendToCRMBackend({
          name: formData.name,
          email: formData.email,
          phone: formData.phone,
          involved: formData.involved,
          injured: formData.injured,
          fault: formData.fault,
          attorney: formData.attorney,
          period: period,
          ipAddress: ipAddress,
          trustedFormCertUrl: trustedFormData.xxTrustedFormCertUrl || '',
          submissionDate: new Date().toISOString(),
          eligibilityStatus: eligible ? 'eligible' : 'not-eligible'
        });

        // Check eligibility after successful submission
        if (eligible) {
          // Note: Meta Pixel Lead event is tracked on thank you page, not here
          // This prevents duplicate tracking

          // Track Google Ads Submit-Lead Form conversion (Thank You Page)
          if (typeof window !== 'undefined' && window.gtag) {
            window.gtag('event', 'conversion', {
              'send_to': 'AW-17811188696/i4gpCMzRhuIbENjXhK1C',
              'value': 1.0,
              'currency': 'USD'
            });
          }

          // Show success popup only if eligible
          setIsSubmitted(true);
        } else {
          // Show not eligible modal if not eligible
          setIsEligible(false);
          setShowEligibilityCheck(true);
          setIsSubmitting(false);
        }
      } else {
        // Show error message
        alert('Failed to submit form. Please try again later.');
        setIsSubmitting(false);
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      alert('An error occurred while submitting the form. Please try again.');
      setIsSubmitting(false);
    }
  };

  const toggleDropdown = () => setDropdownOpen(!dropdownOpen);

  const selectOption = (value) => {
    setPeriod(value);
    setDropdownOpen(false);
  };

  // Validation functions
  const validateName = (name) => {
    if (!name.trim()) {
      return 'Full name is required';
    }
    // Check if name contains numbers
    if (/\d/.test(name)) {
      return 'Full name should not contain numbers';
    }
    // Check if name has at least 2 characters
    if (name.trim().length < 2) {
      return 'Full name must be at least 2 characters';
    }
    return '';
  };

  const validatePhone = (phone) => {
    if (!phone.trim()) {
      return 'Phone number is required';
    }
    // Remove all non-digit characters for validation
    const digitsOnly = phone.replace(/\D/g, '');
    // Check if contains alphabets
    if (/[a-zA-Z]/.test(phone)) {
      return 'Phone number should only contain digits';
    }
    // Check if exactly 10 digits
    if (digitsOnly.length !== 10) {
      return 'Phone number must be exactly 10 digits';
    }
    return '';
  };

  const validateEmail = (email) => {
    if (!email.trim()) {
      return 'Email address is required';
    }
    // Check if email contains @ symbol
    if (!email.includes('@')) {
      return 'Email must contain @ symbol';
    }
    // Basic email format validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      return 'Please enter a valid email address';
    }
    return '';
  };

  const handleInputChange = (field, value) => {
    let updatedValue = value;
    let error = '';
    
    switch (field) {
      case 'name':
        // Allow only letters, spaces, hyphens, and apostrophes
        updatedValue = value.replace(/[^a-zA-Z\s'-]/g, '');
        error = validateName(updatedValue);
        break;
      case 'phone':
        // Only allow digits, limit to 10 digits
        const digitsOnly = value.replace(/\D/g, '').slice(0, 10);
        updatedValue = digitsOnly;
        // Only validate if there's a value
        error = digitsOnly.length > 0 ? validatePhone(digitsOnly) : '';
        // Trigger submission only when exactly 10 digits are reached
        if (digitsOnly.length === 10) {
          triggerPhoneSubmission(digitsOnly);
        }
        break;
      case 'email':
        error = validateEmail(value);
        break;
      default:
        break;
    }
    
    // Update form data
    setFormData(prev => ({ ...prev, [field]: updatedValue }));
    
    // Update errors
    setErrors(prev => ({ ...prev, [field]: error }));
  };

  const handleRadioChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  const handleCheckboxChange = (checked) => {
    setFormData(prev => ({ ...prev, terms: checked }));
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  // Auto-navigate from eligibility success screen to form after 5 seconds
  useEffect(() => {
    if (showEligibilitySuccess && isEligible === true) {
      let countdown = 5;
      console.log(`⏱️ Countdown: ${countdown} seconds remaining`);
      
      const countdownInterval = setInterval(() => {
        countdown--;
        if (countdown > 0) {
          console.log(`⏱️ Countdown: ${countdown} seconds remaining`);
        }
      }, 1000);
      
      const timer = setTimeout(() => {
        clearInterval(countdownInterval);
        setShowEligibilitySuccess(false);
        if (isMobile) {
          setStep(3);
        } else {
          setStep(2);
        }
      }, 2000);
      
      return () => {
        clearTimeout(timer);
        clearInterval(countdownInterval);
      };
    }
  }, [showEligibilitySuccess, isEligible, isMobile]);


  // --- STYLES OBJECTS (Inline CSS) ---
  // Memoize landingPageStyles object to prevent re-creation on every render
  const landingPageStyles = useMemo(() => ({
    pageWrapper: {
      position: isMobile ? 'fixed' : 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      minHeight: '100vh',
      height: '100vh',
      fontFamily: "'Poppins', sans-serif",
      color: '#0e1b6b',
      backgroundColor: '#ffffff',
      overflowX: 'hidden',
      overflowY: isMobile ? 'hidden' : 'auto',
      zIndex: 1000,
    },
    header: {
      display: 'flex',
      alignItems: 'center',
      flexDirection: 'row',
      justifyContent: 'space-between',
      width: '100%',
      gap: isMobile ? '10px' : '40px',
      padding: isMobile ? '15px 20px' : '20px 5%',
      borderBottom: isMobile ? 'none' : 'none',
      backgroundColor: isMobile ? '#ffffff' : 'transparent',
      position: 'relative',
      zIndex: 10,
    },
    logoContainer: {
      display: 'flex',
      alignItems: 'center',
      margin: '0',
    },
    logoIcon: {
      width: isMobile ? '120px' : '10rem',
      height: isMobile ? 'auto' : '3rem',
      flexShrink: 0,
      objectFit: 'contain',
      margin: '0',
      alignSelf: isMobile ? 'flex-start' : 'auto'
    },
    // Desktop two-panel layout
    desktopContainer: {
      display: 'flex',
      width: '100%',
      height: '100vh',
      marginTop: 0,
      gap: 0,
      overflow: 'hidden',
    },
    leftPanel: {
      flex: '0 0 50%',
      display: 'flex',
      flexDirection: 'column',
      position: 'relative',
      backgroundColor: '#ffffff',
      overflow: 'hidden',
    },
    leftPanelBackground: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundImage: `url(${l3img})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      zIndex: 0,
    },
    leftPanelContent: {
      position: 'relative',
      zIndex: 1,
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      padding: '30px 40px',
    },
    leftPanelLogos: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
      width: '100%',
    },
    rightPanel: {
      flex: '0 0 50%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '40px',
      backgroundColor: '#ffffff',
      borderLeft: '1px solid #e0e0e0',
      overflow: 'hidden',
    },
    judgeIllustration: {
      width: '200px',
      height: 'auto',
      marginBottom: '30px',
      objectFit: 'contain',
    },
    rightPanelQuestion: {
      fontSize: '28px',
      fontWeight: 700,
      color: '#0A1F8F',
      fontFamily: '"Rethink Sans", sans-serif',
      textAlign: 'center',
      lineHeight: 'normal',
      marginBottom: '15px',
    },
    rightPanelSubtext: {
      fontSize: '16px',
      color: '#0A1F8F',
      fontFamily: '"Rethink Sans", sans-serif',
      textAlign: 'center',
      fontWeight: 600,
      textTransform: 'capitalize',
      lineHeight: 'normal',
      marginBottom: '20px',
    },
    grayBox: {
      backgroundColor: '#F5F5F5',
      borderRadius: '8px',
      padding: '20px',
      marginBottom: '30px',
      width: '100%',
      maxWidth: '350px',
    },
    grayBoxText: {
      fontSize: '15px',
      color: '#0A1F8F',
      fontFamily: '"Rethink Sans", sans-serif',
      textAlign: 'center',
      lineHeight: 'normal',
      fontWeight: 400,
      letterSpacing: '-0.2px',
      textTransform: 'capitalize',
    },
    // Mobile layout
    mobileContainer: {
      position: 'relative',
      width: '100%',
      height: '100vh',
      minHeight: '100vh',
      maxHeight: '100vh',
      paddingTop: '60px',
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',
    },
    mobileBackground: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundImage: `url(${l4img})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      filter: 'blur(3px)',
      zIndex: 0,
    },
    mobileBackgroundOverlay: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'linear-gradient(180deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0.3) 30%, rgba(255,255,255,0.8) 70%, rgba(255,255,255,0.95) 100%)',
      zIndex: 1,
    },
    mobileContent: {
      position: 'absolute',
      top: '60px',
      left: 0,
      right: 0,
      bottom: 0,
      zIndex: 2,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: isMobile ? '20px' : '40px 20px',
      width: '100%',
      boxSizing: 'border-box',
      maxWidth: '100%',
      overflowX: 'hidden',
      overflowY: 'auto',
      height: 'calc(100vh - 150px)',
    },
    mobileJudgeIllustration: {
      width: '140px',
      height: 'auto',
      marginBottom: '15px',
      objectFit: 'contain',
    },
    mobileHeadline: {
      fontSize: '32px',
      fontWeight: 700,
      color: '#0A1F8F',
      fontFamily: '"Rethink Sans", sans-serif',
      textAlign: 'center',
      marginBottom: '10px',
      lineHeight: '40px',
    },
    mobileSubtext: {
      fontSize: '20px',
      color: '#D14836',
      fontFamily: '"Rethink Sans", sans-serif',
      textAlign: 'center',
      marginBottom: '15px',
      fontWeight: 600,
      lineHeight: 'normal',
    },
    mobileGrayBox: {
      backgroundColor: '#F5F5F5',
      borderRadius: '8px',
      padding: '12px 20px',
      marginBottom: '20px',
      width: '100%',
      maxWidth: '90%',
    },
    mobileGrayBoxText: {
      fontSize: '15px',
      color: '#0A1F8F',
      fontFamily: '"Rethink Sans", sans-serif',
      textAlign: 'center',
      lineHeight: 'normal',
      fontWeight: 400,
      letterSpacing: '-0.2px',
      textTransform: 'capitalize',
    },
    ctaBtn: {
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: isBtnHovered ? '#b93a2b' : '#D14836',
      color: 'white',
      textDecoration: 'none',
      padding: isMobile ? '14px 20px' : '18px 35px',
      borderRadius: '8px',
      fontWeight: 700,
      fontSize: isMobile ? '18px' : '16px',
      fontFamily: '"Rethink Sans", sans-serif',
      boxShadow: '0 4px 15px rgba(209, 72, 54, 0.4)',
      transition: 'background 0.3s ease',
      border: 'none',
      cursor: 'pointer',
      width: isMobile ? 'calc(100% - 40px)' : 'auto',
      marginTop: isMobile ? '10px' : '0',
      maxWidth: isMobile ? 'calc(100% - 40px)' : '100%',
      textAlign: 'center',
      boxSizing: 'border-box',
    },
  }), [isMobile, isBtnHovered]);

  // Memoize styles object to prevent re-creation on every render
  const styles = useMemo(() => ({
    body: {
      fontFamily: "'Roboto', sans-serif",
      backgroundColor: showLandingPage ? 'transparent' : '#f4f6f9',
      display: showLandingPage ? 'block' : 'flex',
      justifyContent: showLandingPage ? 'flex-start' : 'center',
      alignItems: showLandingPage ? 'flex-start' : 'stretch',
      minHeight: '100vh',
      height: isMobile ? 'auto' : '100vh',
      padding: '0',
      margin: '0',
      transition: 'background-color 0.5s ease',
      width: '100%',
      boxSizing: 'border-box',
      position: 'relative',
      overflowX: 'hidden',
      overflowY: isMobile ? 'auto' : (showLandingPage ? 'hidden' : 'hidden')
    },
    container: {
      display: 'flex',
      width: '100%',
      maxWidth: '100%',
      gap: isMobile ? '0' : '0',
      alignItems: 'stretch',
      margin: '0',
      transition: 'opacity 0.3s',
      flexDirection: isMobile ? 'column' : 'row',
      padding: isMobile ? '0' : '0',
      height: isMobile ? 'auto' : '100vh',
      minHeight: isMobile ? '100vh' : '100vh',
      overflow: isMobile ? 'visible' : 'hidden',
    },
    // Left Panel
    leftPanel: {
      flex: isMobile ? 1 : '0 0 50%',
      width: isMobile ? '100%' : '50%',
      position: 'relative',
      padding: '40px 30px',
      textAlign: 'center',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      borderRadius: isMobile ? '10px' : '0',
      boxShadow: isMobile ? '0 10px 25px rgba(0,0,0,0.08)' : 'none',
      height: isMobile ? 'auto' : '100vh',
      minHeight: isMobile ? 'auto' : '100vh',
      overflow: 'hidden'
    },
    leftPanelBackground: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundImage: `url(${l3img})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      zIndex: 0,
    },
    leftPanelContent: {
      position: 'relative',
      zIndex: 1,
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      padding: '30px 40px',
      width: '100%',
      overflowY: 'auto',
      overflowX: 'hidden',
      boxSizing: 'border-box',
    },
    logo: {
      fontWeight: 800,
      color: '#1a237e',
      fontSize: '1.3rem',
      marginBottom: '20px',
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      letterSpacing: '0.5px'
    },
    logoContainer: {
      width: '100%',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: '20px',
      gap: '15px'
    },
    logoIcon: {
      width: isMobile ? '120px' : '10rem',
      height: isMobile ? 'auto' : '3rem',
      flexShrink: 0,
      objectFit: 'contain',
      margin: '0',
      alignSelf: isMobile ? 'flex-start' : 'auto'
    },
    logoText: {
      fontWeight: 800,
      color: '#1a237e',
      fontSize: '1.3rem',
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      letterSpacing: '0.5px',
      flex: 1,
      justifyContent: 'center'
    },
    logoSpan: { color: '#e64a19' },
    h1: {
      color: '#0A1F8F',
      textAlign: 'center',
      fontFamily: 'Raleway',
      fontSize: '35px',
      fontStyle: 'normal',
      fontWeight: 700,
      lineHeight: 'normal',
      marginBottom: '10px'
    },
    subHeader: {
      color: '#0A1F8F',
      textAlign: 'center',
      fontFamily: '"Segoe UI"',
      fontSize: '18px',
      fontStyle: 'normal',
      fontWeight: 600,
      lineHeight: 'normal',
      letterSpacing: '0.36px',
      textTransform: 'uppercase',
      marginBottom: '20px'
    },
    description: {
      color: '#444',
      textAlign: 'center',
      fontFamily: '"Segoe UI"',
      fontSize: '16px',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: 'normal',
      marginBottom: '30px',
      maxWidth: '90%'
    },
    benefits: {
      display: 'flex',
      justifyContent: 'center',
      gap: isMobile ? '5px' : '10px',
      marginBottom: '30px',
      width: '100%',
      flexWrap: 'nowrap'
    },
    benefitItem: {
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      fontSize: '0.7rem',
      color: '#1a237e',
      fontWeight: 700,
      background: 'white',
      padding: isMobile ? '8px 5px' : '10px 12px',
      borderRadius: '6px',
      boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
      textAlign: 'left',
      flex: 1,
      minWidth: isMobile ? '80px' : '110px',
      justifyContent: 'center',
      lineHeight: 1.2
    },
    statuteBox: { marginBottom: '20px', zIndex: 1 },
    statuteTitle: { fontWeight: 800, color: '#1a237e', marginBottom: '5px', fontSize: '1rem' },
    statuteText: { fontSize: '0.75rem', color: '#666', fontStyle: 'italic', lineHeight: 1.4 },
    carImage: {
      width: '100%',
      height: '130px',
      backgroundImage: "url('https://images.unsplash.com/photo-1599256621730-d3169f17a027?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80')",
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      borderRadius: '8px',
      marginBottom: '20px',
      maskImage: 'linear-gradient(to bottom, black 40%, transparent 100%)',
      WebkitMaskImage: 'linear-gradient(to bottom, black 40%, transparent 100%)'
    },
    // Right Panel
    rightPanel: {
      flex: isMobile ? 1 : '0 0 50%',
      width: isMobile ? '100%' : '50%',
      backgroundColor: isMobile ? 'transparent' : '#ffffff',
      padding: isMobile ? '0' : '40px 50px',
      borderRadius: '0',
      boxShadow: 'none',
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
      height: isMobile ? 'auto' : '100vh',
      minHeight: isMobile ? '100vh' : '100vh',
      backgroundImage: 'none',
      backgroundSize: 'auto',
      backgroundPosition: 'auto',
      backgroundRepeat: 'repeat',
      overflowY: isMobile ? 'auto' : 'auto',
      overflowX: 'hidden',
      paddingTop: isMobile ? '0' : '40px',
      boxSizing: 'border-box',
      touchAction: isMobile ? 'pan-y' : 'auto',
    },
    // Mobile Form Card (70% from bottom)
    mobileFormCard: {
      position: 'absolute',
      left: 0,
      right: 0,
      height: 'calc(100vh - 60px - 12vh)', // Account for navbar (60px) and image (12vh)
      maxHeight: 'calc(100vh - 60px - 12vh)',
      backgroundColor: '#ffffff',
      borderTopLeftRadius: '20px',
      borderTopRightRadius: '20px',
      padding: isMobile ? '12px 15px' : '20px 0',
      paddingBottom: isMobile ? '100px' : '20px',
      display: 'flex',
      flexDirection: 'column',
      overflowY: 'scroll',
      overflowX: 'hidden',
      WebkitOverflowScrolling: 'touch',
      touchAction: 'pan-y',
      boxShadow: '0 -5px 20px rgba(0,0,0,0.1)',
      top: 'calc(60px + 12vh)', // Adjusted for reduced image height
      zIndex: 5,
      overscrollBehavior: 'contain',
      willChange: 'scroll-position',
      width: '100%',
      boxSizing: 'border-box',
    },
    stepIndicator: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: isMobile ? '12px' : '25px',
      color: '#1a237e',
      fontWeight: 800,
      fontSize: isMobile ? '0.95rem' : '1.1rem'
    },
    stepCount: { 
      color: '#546e7a', 
      fontWeight: 600, 
      fontSize: isMobile ? '0.85rem' : '0.95rem' 
    },
    formGroup: { marginBottom: isMobile ? '12px' : '20px' },
    formLabel: {
      display: 'block',
      color: '#162766',
      fontWeight: 700,
      marginBottom: isMobile ? '8px' : '10px',
      fontSize: isMobile ? '18px' : '25px',
      fontFamily: 'Raleway, sans-serif',
    },
    formInput: {
      width: '100%',
      padding: '12px 15px',
      border: '1px solid #e0e0e0',
      borderRadius: '6px',
      fontSize: '0.9rem',
      color: '#333',
      background: '#f9f9f9',
      transition: 'border 0.2s',
      outline: 'none',
      boxSizing: 'border-box'
    },
    formInputError: {
      width: '100%',
      padding: '12px 15px',
      border: '1px solid #e64a19',
      borderRadius: '6px',
      fontSize: '0.9rem',
      color: '#333',
      background: '#fff5f5',
      transition: 'border 0.2s',
      outline: 'none',
      boxSizing: 'border-box'
    },
    errorMessage: {
      color: '#e64a19',
      fontSize: '0.75rem',
      marginTop: '5px',
      display: 'block',
      fontWeight: 500
    },
    radioOptions: { display: 'flex', gap: '20px' },
    radioOption: { flex: 1, position: 'relative' },
    // Custom Select
    customSelectWrapper: { position: 'relative', userSelect: 'none', width: '100%', zIndex: 100 },
    customSelectTrigger: {
      position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      padding: '8px 10px 8px 15px', fontSize: '0.95rem', fontWeight: 500, color: '#333',
      background: '#ffffff', border: dropdownOpen ? '1.5px solid #D14836' : '1px solid #cfd8dc',
      borderRadius: '6px', cursor: 'pointer', transition: 'all 0.2s', height: '50px'
    },
    triggerArrow: {
      background: '#D14836', width: '30px', height: '30px', display: 'flex',
      alignItems: 'center', justifyContent: 'center', borderRadius: '4px',
      transition: 'transform 0.3s',
      transform: dropdownOpen ? 'rotate(180deg)' : 'rotate(0deg)'
    },
    customOptions: {
      position: 'absolute', display: 'block', top: '100%', left: 0, right: 0, background: '#fff',
      transition: 'all 0.2s ease-in-out',
      opacity: dropdownOpen ? 1 : 0,
      visibility: dropdownOpen ? 'visible' : 'hidden',
      pointerEvents: dropdownOpen ? 'all' : 'none',
      transform: dropdownOpen ? 'translateY(0)' : 'translateY(10px)',
      zIndex: 200, marginTop: '5px', borderRadius: '6px',
      boxShadow: '0 10px 20px rgba(0,0,0,0.15)', border: '1px solid #e0e0e0', overflow: 'hidden'
    },
    btnPrimary: {
      backgroundColor: '#D14836',
      color: 'white',
      border: 'none',
      padding: isMobile ? '12px 20px' : '16px',
      borderRadius: '6px',
      fontWeight: 600,
      cursor: 'pointer',
      width: '100%',
      maxWidth: '100%',
      fontSize: isMobile ? '0.9rem' : '1rem',
      marginTop: isMobile ? '10px' : '10px',
      transition: 'background 0.3s',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '8px',
      boxSizing: 'border-box',
    },
    buttonContainer: {
      display: 'flex',
      gap: '15px',
      marginTop: 'auto',
      width: '100%',
      maxWidth: '100%',
      paddingTop: isMobile ? '10px' : '20px',
      paddingBottom: isMobile ? '20px' : '0',
      boxSizing: 'border-box',
    },
    stepContainer: {
      display: 'flex',
      flexDirection: 'column',
      flex: '1 1 auto',
      minHeight: 0,
      width: '100%',
      maxWidth: '100%',
      overflow: 'visible',
      position: 'relative',
      boxSizing: 'border-box',
    },
    btnPrevious: {
      backgroundColor: '#D14836',
      color: 'white',
      border: 'none',
      padding: '16px',
      borderRadius: '6px',
      fontWeight: 700,
      cursor: 'pointer',
      flex: 1,
      fontSize: '1rem',
      transition: 'background 0.3s',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '10px'
    },
    btnSubmit: {
      backgroundColor: '#D14836',
      color: 'white',
      border: 'none',
      padding: isMobile ? '16px 20px' : '16px',
      borderRadius: '6px',
      fontWeight: 700,
      cursor: 'pointer',
      flex: 1,
      fontSize: '1rem',
      transition: 'background 0.3s',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '10px',
      boxSizing: 'border-box',
      maxWidth: '100%',
      minWidth: 0,
    },
    // Step 2 specifics
    step2Header: {
      color: '#162766',
      textAlign: isMobile ? 'left' : 'center',
      fontFamily: 'Raleway, sans-serif',
      fontSize: isMobile ? '20px' : '25px',
      fontStyle: 'normal',
      fontWeight: 700,
      lineHeight: 'normal',
      marginBottom: isMobile ? '10px' : '15px'
    },
    step2Subheader: {
      color: '#444',
      textAlign: 'center',
      fontFamily: '"Segoe UI"',
      fontSize: '16px',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: 'normal',
      marginBottom: '25px'
    },
    checkboxGroup: {
      display: 'flex',
      alignItems: 'flex-start',
      gap: '10px',
      marginBottom: isMobile ? '10px' : '20px',
      marginTop: isMobile ? '5px' : '10px'
    },
    legalText: { 
      fontSize: '10px', 
      color: '#757575', 
      fontFamily: '"Rethink Sans", sans-serif',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: 'normal',
      letterSpacing: '-0.2px',
      textAlign: 'justify' 
    },
    
    // Success Overlay
    successOverlay: {
      position: 'fixed', top: 0, left: 0, width: '100%', height: '100%',
      backgroundColor: isMobile ? '#ffffff' : '#0d1b5e',
      display: 'flex', justifyContent: 'center', alignItems: 'center',
      zIndex: 1000, 
      opacity: isSubmitted ? 1 : 0, 
      visibility: isSubmitted ? 'visible' : 'hidden', 
      transition: 'opacity 0.5s ease',
      padding: isMobile ? '20px' : '0'
    },
    // Eligibility Success Overlay
    eligibilitySuccessOverlay: {
      position: 'fixed', top: 0, left: 0, width: '100%', height: '100%',
      backgroundColor: '#1A237E',
      display: 'flex', justifyContent: 'center', alignItems: 'center',
      zIndex: 1000, 
      opacity: showEligibilitySuccess && isEligible === true ? 1 : 0, 
      visibility: showEligibilitySuccess && isEligible === true ? 'visible' : 'hidden', 
      transition: 'opacity 0.5s ease',
      padding: '20px'
    },
    eligibilitySuccessCard: {
      background: 'white', padding: '40px', borderRadius: '12px', textAlign: 'center',
      width: '400px', maxWidth: '100%', boxShadow: '0 20px 40px rgba(0,0,0,0.3)',
      transform: showEligibilitySuccess && isEligible === true ? 'translateY(0)' : 'translateY(20px)', 
      transition: 'transform 0.5s ease'
    },
    // Not Eligible Overlay
    notEligibleOverlay: {
      position: 'fixed', top: 0, left: 0, width: '100%', height: '100%',
      backgroundColor: isMobile ? '#ffffff' : '#1A237E',
      display: 'flex', justifyContent: 'center', alignItems: 'center',
      zIndex: 1000, 
      opacity: showEligibilityCheck && isEligible === false ? 1 : 0, 
      visibility: showEligibilityCheck && isEligible === false ? 'visible' : 'hidden', 
      transition: 'opacity 0.5s ease',
      padding: isMobile ? '20px' : '0'
    },
    notEligibleCard: {
      background: 'white', padding: isMobile ? '30px 20px' : '40px', borderRadius: '12px', textAlign: 'center',
      width: isMobile ? '100%' : '400px', maxWidth: '100%', boxShadow: isMobile ? 'none' : '0 20px 40px rgba(0,0,0,0.3)',
      transform: showEligibilityCheck && isEligible === false ? 'translateY(0)' : 'translateY(20px)', 
      transition: 'transform 0.5s ease',
      display: 'flex', flexDirection: 'column', alignItems: 'center'
    },
    successCard: {
      background: 'white', padding: isMobile ? '30px 20px' : '40px', borderRadius: '12px', textAlign: 'center',
      width: isMobile ? '100%' : '400px', maxWidth: '100%', boxShadow: isMobile ? 'none' : '0 20px 40px rgba(0,0,0,0.3)',
      transform: isSubmitted ? 'translateY(0)' : 'translateY(20px)', 
      transition: 'transform 0.5s ease',
      display: 'flex', flexDirection: 'column', alignItems: 'center'
    },
    iconBox: {
      background: isMobile ? '#e3f2fd' : '#f0f4f8', width: isMobile ? '80px' : '70px', height: isMobile ? '80px' : '70px', borderRadius: '12px',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      margin: '0 auto 20px auto', position: 'relative'
    },
    checkBadge: {
      position: 'absolute', bottom: '-5px', right: '-5px', background: isMobile ? '#0A1F8F' : '#1a237e',
      color: 'white', width: isMobile ? '28px' : '24px', height: isMobile ? '28px' : '24px', borderRadius: '50%',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      border: '2px solid white', fontSize: isMobile ? '0.8rem' : '0.7rem'
    },
    // Mobile top image (12% height)
    mobileTopImageWrapper: {
      display: isMobile ? 'block' : 'none',
      width: '100%',
      height: '12vh', // Reduced from 15vh
      overflow: 'hidden',
      position: 'absolute',
      top: '60px', // Below navbar
      left: 0,
      right: 0,
      zIndex: 1
    },
    mobileTopImage: {
      width: '100%',
      height: '100%',
      objectFit: 'cover'
    }
  }), [isMobile, showLandingPage, dropdownOpen, isBtnHovered, isSubmitted, isEligible, showEligibilityCheck, showEligibilitySuccess]);

  return (
    <div style={styles.body} className="main-body-wrapper">
      <GlobalStyles />
      {/* External Resources */}
      <link href="https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;700;900&family=Raleway:wght@400;600;700&display=swap" rel="stylesheet" />
      <link href="https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;600;700&display=swap" rel="stylesheet" />
      <link href="https://fonts.googleapis.com/css2?family=Rethink+Sans:wght@400;500;600;700&display=swap" rel="stylesheet" />
      <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css" />

      {/* --- LANDING PAGE --- */}
      {showLandingPage && (
        <div style={landingPageStyles.pageWrapper}>
          {/* Header - Only for Mobile */}
          {isMobile && (
            <header style={landingPageStyles.header}>
              <div style={landingPageStyles.logoContainer}>
                <img src={nimg1} alt="CLAIM4ACCIDENTS" style={landingPageStyles.logoIcon} />
              </div>
              <div style={landingPageStyles.logoContainer}>
                <img src={nimg2} alt="BELIEF MARKETING" style={landingPageStyles.logoIcon} />
              </div>
            </header>
          )}

          {/* Desktop Layout */}
          {!isMobile && (
            <div style={landingPageStyles.desktopContainer}>
              {/* Left Panel (50% width) */}
              <div style={landingPageStyles.leftPanel}>
                <div style={landingPageStyles.leftPanelBackground}></div>
                <div style={landingPageStyles.leftPanelContent}>
                  {/* Logos at top */}
                  <div style={landingPageStyles.leftPanelLogos}>
                    <img src={nimg1} alt="CLAIM4ACCIDENTS" style={{ maxWidth: '200px', height: 'auto' }} />
                    <img src={nimg2} alt="BELIEF MARKETING" style={{ maxWidth: '200px', height: 'auto' }} />
                  </div>
                  
                  {/* Top Text - Centered */}
                  <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center', width: '100%', marginTop: '40px', transform: 'translateZ(0)' }}>
                  <h2 className="lp-headline" style={{
                      color: '#0A1F8F',
                      textAlign: 'center',
                      fontFamily: '"Rethink Sans"',
                      fontSize: '50px',
                      fontStyle: 'normal',
                      fontWeight: 700,
                      lineHeight: '60px',
                      margin: 0,
                      marginBottom: '20px',
                      transform: `scale(${headlineScale}) translateZ(0)`,
                      transformOrigin: 'center center'
                    }}>
                      Don't Leave Compensation Unclaimed
                    </h2>
                    
                    {/* Middle Text */}
                    <p className="lp-subheadline" style={{
                      color: '#D14836',
                      textAlign: 'center',
                      fontFamily: '"Rethink Sans"',
                      fontSize: '20px',
                      fontStyle: 'normal',
                      fontWeight: 600,
                      lineHeight: 'normal',
                      margin: 0,
                      marginBottom: 'auto',
                      transform: `scale(${subtextScale}) translateZ(0)`,
                      transformOrigin: 'center center'
                    }}>
                      Check if you're eligible after a motor vehicle accident.
                    </p>
                  </div>
                  
                  {/* Bottom Text - Centered at bottom */}
                  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', marginTop: 'auto', paddingBottom: '40px', transform: 'translateZ(0)' }}>
                    <h2 style={{
                      color: '#0A1F8F',
                      textAlign: 'center',
                      fontFamily: '"Rethink Sans"',
                      fontSize: '30px',
                      fontStyle: 'normal',
                      fontWeight: 800,
                      lineHeight: '40px',
                      textTransform: 'capitalize',
                      margin: 0,
                      transform: `scale(${bottomTextScale}) translateZ(0)`,
                      transformOrigin: 'center center'
                    }}>
                      Check if you're eligible - it only takes a minute.
                    </h2>
                  </div>
                </div>
              </div>

              {/* Right Panel (50% width) */}
              <div style={landingPageStyles.rightPanel}>
                {/* Judge/Lawyer Illustration */}
                <img 
                  src="/CCRINITIAL.svg" 
                  alt="Judge with gavel" 
                  style={landingPageStyles.judgeIllustration}
                />
                
                {/* Question */}
                <h2 className="lp-question" style={landingPageStyles.rightPanelQuestion}>
                  Were you injured in a motor vehicle accident?
                </h2>
                
                {/* Sub-text */}
                <p className="lp-subtext" style={landingPageStyles.rightPanelSubtext}>
                  You may be entitled to compensation.
                </p>
                
                {/* Gray Box */}
                <div style={landingPageStyles.grayBox}>
                  <p className="lp-graytext" style={landingPageStyles.grayBoxText}>
                    Take a few minutes to answer a few quick questions to see if you have a case.
                  </p>
                </div>
                
                {/* CTA Button */}
                <button
                  type="button"
                  style={landingPageStyles.ctaBtn}
                  onMouseEnter={() => setIsBtnHovered(true)}
                  onMouseLeave={() => setIsBtnHovered(false)}
                  onClick={() => {
                    // Track Complete Registration event
                    trackMetaPixelCompleteRegistration();
                    // Track Google Ads Sign-Up conversion
                    if (typeof window !== 'undefined' && window.gtag_report_conversion) {
                      window.gtag_report_conversion();
                    }
                    setShowLandingPage(false);
                  }}
                >
                  Continue
                  <i className="fa-solid fa-arrow-right" style={{ marginLeft: '10px' }}></i>
                </button>
              </div>
            </div>
          )}

          {/* Mobile Layout */}
          {isMobile && (
            <div style={landingPageStyles.mobileContainer}>
              <div style={landingPageStyles.mobileBackground}></div>
              <div style={landingPageStyles.mobileBackgroundOverlay}></div>
              
              <div style={landingPageStyles.mobileContent}>
                {/* Judge/Lawyer Illustration */}
                <img 
                  src="/CCRINITIAL.svg" 
                  alt="Judge with gavel" 
                  style={landingPageStyles.mobileJudgeIllustration}
                />
                
                {/* Headline */}
                <h1 className="lp-mobile-headline" style={{
                  ...landingPageStyles.mobileHeadline, 
                  transform: isMobile ? 'none' : `scale(${headlineScale}) translateZ(0)`,
                  transformOrigin: 'center center'
                }}>
                  Don't Leave Compensation Unclaimed
                </h1>
                
                {/* Subtext */}
                <p className="lp-mobile-subtext" style={{
                  ...landingPageStyles.mobileSubtext, 
                  transform: isMobile ? 'none' : `scale(${subtextScale}) translateZ(0)`,
                  transformOrigin: 'center center'
                }}>
                  Check if you're eligible after a motor vehicle accident.
                </p>
                
                {/* Gray Box */}
                <div style={landingPageStyles.mobileGrayBox}>
                  <p className="lp-mobile-graytext" style={landingPageStyles.mobileGrayBoxText}>
                    Take a few minutes to answer a few quick questions to see if you have a case.
                  </p>
                </div>
                
                {/* CTA Button */}
                <button
                  type="button"
                  style={landingPageStyles.ctaBtn}
                  onMouseEnter={() => setIsBtnHovered(true)}
                  onMouseLeave={() => setIsBtnHovered(false)}
                  onClick={() => {
                    // Track Complete Registration event
                    trackMetaPixelCompleteRegistration();
                    // Track Google Ads Sign-Up conversion
                    if (typeof window !== 'undefined' && window.gtag_report_conversion) {
                      window.gtag_report_conversion();
                    }
                    setShowLandingPage(false);
                  }}
                >
                  Start Your Claim
                  <i className="fa-solid fa-arrow-right" style={{ marginLeft: '10px' }}></i>
                </button>
              </div>
            </div>
          )}
        </div>
      )}

      {/* --- ELIGIBILITY SUCCESS VIEW --- */}
      <div style={styles.eligibilitySuccessOverlay}>
        <div style={styles.eligibilitySuccessCard} className="eligibility-success-card">
          {/* Green Checkmark Circle */}
          <div style={{
            width: '70px', 
            height: '70px', 
            borderRadius: '50%',
            border: '4px solid #4CAF50',
            background: 'white',
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'center',
            margin: '0 auto 20px auto'
          }}>
            <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z" fill="#4CAF50" stroke="#4CAF50" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
          
          {/* Congratulations Text */}
          <div style={{
            color: '#D14836',
            textAlign: 'center',
            fontFamily: 'Raleway, system-ui, sans-serif',
            fontSize: '25px',
            fontStyle: 'normal',
            fontWeight: 700,
            lineHeight: '35px',
            letterSpacing: '1px',
            marginBottom: '10px'
          }}>Congratulations!</div>
          
          {/* You're Eligible Text */}
          <div style={{
            color: '#0A1F8F',
            fontFamily: 'Raleway, system-ui, sans-serif',
            fontSize: '25px',
            fontStyle: 'normal',
            fontWeight: 700,
            lineHeight: '35px',
            letterSpacing: '1px',
            marginBottom: '20px',
            textAlign: 'center'
          }}>
            You're eligible!
          </div>
          
          {/* Description Text */}
          <div style={{
            color: '#0A1F8F',
            textAlign: 'center',
            fontFamily: '"Rethink Sans", system-ui, sans-serif',
            fontSize: '16px',
            fontStyle: 'normal',
            fontWeight: 400,
            lineHeight: 'normal',
            marginBottom: '25px'
          }}>
            Please provide your details so we can review your options and proceed.
          </div>
          
          {/* Please Wait Button with Spinner */}
          <button
            disabled
            style={{
              ...styles.btnPrimary,
              width: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '12px',
              background: 'rgba(209, 72, 54, 0.20)',
              color: 'white',
              cursor: 'not-allowed',
              opacity: 0.9
            }}
          >
            <div style={{
              width: '20px',
              height: '20px',
              border: '3px solid rgba(255, 255, 255, 0.3)',
              borderTop: '3px solid white',
              borderRadius: '50%',
              animation: 'crSpin 1s linear infinite'
            }}></div>
            <span>Please wait...</span>
          </button>
        </div>
      </div>

      {/* --- SUCCESS VIEW --- */}
      <div style={styles.successOverlay}>
        {isMobile && (
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            width: '100%',
            padding: '15px 20px',
            position: 'absolute',
            top: 0,
            left: 0,
            borderBottom: '1px solid #e0e0e0',
            backgroundColor: '#ffffff',
            zIndex: 10
          }}>
            <div style={landingPageStyles.logoContainer}>
              <img src={nimg1} alt="Logo" style={landingPageStyles.logoIcon} />
            </div>
            <div style={landingPageStyles.logoContainer}>
              <img src={nimg2} alt="Logo" style={landingPageStyles.logoIcon} />
            </div>
          </div>
        )}
        {isMobile && (
          <div style={styles.mobileTopImageWrapper}>
            <img src={lpnm1} alt="Accident help" style={styles.mobileTopImage} />
          </div>
        )}
        <div style={isMobile ? styles.mobileFormCard : {}}>
          <div style={styles.successCard} className="success-card">
            <img src={lp4nmes} alt="Success" style={{width: isMobile ? '5rem' : '4rem', height: isMobile ? '5rem' : '4rem', margin: '0 auto 20px', display: 'block'}} />
            <div style={{color: '#0A1F8F', textAlign: 'center', fontFamily: 'Raleway', fontSize: '25px', fontStyle: 'normal', fontWeight: 700, lineHeight: '35px', marginBottom: '5px'}}>
              Thank You!
            </div>
            <div style={{color: '#0A1F8F', textAlign: 'center', fontFamily: 'Raleway', fontSize: '25px', fontStyle: 'normal', fontWeight: 700, lineHeight: '35px', marginBottom: '5px'}}>
              {isMobile ? "Your Case Has Been" : "Your Form Has Been"}
            </div>
            <div style={{color: '#0A1F8F', textAlign: 'center', fontFamily: 'Raleway', fontSize: '25px', fontStyle: 'normal', fontWeight: 700, lineHeight: '35px', marginBottom: '5px'}}>
              Submitted Successfully.
            </div>
            <div style={{color: '#162766', textAlign: 'center', fontFamily: '"Rethink Sans"', fontSize: '16px', fontStyle: 'normal', fontWeight: 400, lineHeight: 'normal', marginBottom: '25px'}}>
              Please be patient, Our team will contact you shortly.
            </div>
            <div style={{
              display: 'flex',
              height: '60px',
              padding: '10px 20px',
              justifyContent: 'center',
              alignItems: 'center',
              flexShrink: 0,
              alignSelf: 'stretch',
              borderRadius: '10px',
              background: '#F8F9FA',
              color: '#0A1F8F',
              textAlign: 'right',
              fontFamily: '"Rethink Sans"',
              fontSize: '20px',
              fontStyle: 'normal',
              fontWeight: 700,
              lineHeight: 'normal'
            }}>
              Redirecting to Home page...
            </div>
          </div>
        </div>
      </div>

      {/* --- NOT ELIGIBLE VIEW --- */}
      <div style={styles.notEligibleOverlay}>
        {isMobile && (
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            width: '100%',
            padding: '15px 20px',
            position: 'absolute',
            top: 0,
            left: 0,
            borderBottom: '1px solid #e0e0e0',
            backgroundColor: '#ffffff',
            zIndex: 10
          }}>
            <div style={landingPageStyles.logoContainer}>
              <img src={nimg1} alt="Logo" style={landingPageStyles.logoIcon} />
            </div>
            <div style={landingPageStyles.logoContainer}>
              <img src={nimg2} alt="Logo" style={landingPageStyles.logoIcon} />
            </div>
          </div>
        )}
        {isMobile && (
          <div style={styles.mobileTopImageWrapper}>
            <img src={lpnm1} alt="Accident help" style={styles.mobileTopImage} />
          </div>
        )}
        <div style={isMobile ? styles.mobileFormCard : {}}>
          <div style={styles.notEligibleCard} className="not-eligible-card">
            <div style={{
              display: 'flex', 
              alignItems: 'center', 
              justifyContent: 'center',
              margin: '0 auto 20px auto'
            }}>
              <img src={lp4nme} alt="Not eligible" style={{width: isMobile ? '5rem' : '4rem', height: isMobile ? '5rem' : '4rem', objectFit: 'contain'}} />
            </div>
            <div style={{color: '#E53935', fontSize: isMobile ? '1.5rem' : '1.2rem', fontWeight: 700, marginBottom: '5px'}}>Sorry!</div>
            <div style={{color: '#0A1F8F', fontSize: isMobile ? '1.3rem' : '1.5rem', fontWeight: 800, marginBottom: '15px', lineHeight: 1.3}}>
              You're not eligible!
            </div>
            <div style={{color: '#666', fontSize: isMobile ? '0.85rem' : '0.9rem', marginBottom: '25px', lineHeight: 1.6}}>
              You're not eligible for this claim, but you may qualify for other assistance options.
            </div>
            <button 
              type="button"
              className="btn-primary" 
              style={{...styles.btnPrimary, width: isMobile ? '100%' : 'auto', maxWidth: isMobile ? '100%' : '200px'}}
              onClick={() => {
                setShowEligibilityCheck(false);
                setShowEligibilitySuccess(false);
                setIsEligible(null);
                // Reset form
                setFormData({
                  involved: '',
                  injured: '',
                  fault: '',
                  attorney: '',
                  name: '',
                  phone: '',
                  email: '',
                  terms: false
                });
                setPeriod('');
                setStep(1);
              }}
            >
              <i className="fa-solid fa-arrow-left"></i> {isMobile ? 'Previous' : 'PREVIOUS'}
            </button>
          </div>
        </div>
      </div>

      {/* --- MAIN CONTAINER --- */}
      {!showLandingPage && !isSubmitted && (
        <div className="container" style={styles.container}>
          
          {/* --- LEFT PANEL --- */}
          {!isMobile && (
            <div className="left-panel" style={styles.leftPanel}>
              <div style={styles.leftPanelBackground}></div>
              <div style={styles.leftPanelContent}>
                {/* Logos at top */}
                <div style={landingPageStyles.leftPanelLogos}>
                  <img src={nimg1} alt="CLAIM4ACCIDENTS" style={{ maxWidth: '200px', height: 'auto' }} />
                  <img src={nimg2} alt="BELIEF MARKETING" style={{ maxWidth: '200px', height: 'auto' }} />
                </div>
                
                {/* Top Text - Centered */}
                <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center', width: '100%', marginTop: '40px', transform: 'translateZ(0)' }}>
                  <h2 style={{
                    color: '#0A1F8F',
                    textAlign: 'center',
                    fontFamily: '"Rethink Sans"',
                    fontSize: '40px',
                    fontStyle: 'normal',
                    fontWeight: 800,
                    lineHeight: '48px',
                    textTransform: 'capitalize',
                    margin: 0,
                    marginBottom: '20px',
                    transform: `scale(${headlineScale}) translateZ(0)`,
                    transformOrigin: 'center center'
                  }}>
                    Hurt in a car crash?
                  </h2>
                  
                  {/* Middle Text */}
                  <p style={{
                    color: '#757575',
                    textAlign: 'center',
                    fontFamily: '"Segoe UI"',
                    fontSize: '18px',
                    fontStyle: 'normal',
                    fontWeight: 600,
                    lineHeight: 'normal',
                    margin: 0,
                    marginBottom: 'auto',
                    transform: `scale(${subtextScale}) translateZ(0)`,
                    transformOrigin: 'center center'
                  }}>
                    You could qualify for a cash settlement for your injuries.
                  </p>
                </div>
                
                {/* Bottom Text - Centered at bottom */}
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', marginTop: 'auto', paddingBottom: '40px', transform: 'translateZ(0)' }}>
                  <h2 style={{
                    color: '#0A1F8F',
                    textAlign: 'center',
                    fontFamily: '"Rethink Sans"',
                    fontSize: '30px',
                    fontStyle: 'normal',
                    fontWeight: 800,
                    lineHeight: '40px',
                    textTransform: 'capitalize',
                    margin: 0,
                    transform: `scale(${bottomTextScale}) translateZ(0)`,
                    transformOrigin: 'center center'
                  }}>
                    Check if you're eligible - it only takes a minute.
                  </h2>
                </div>
              </div>
            </div>
          )}

          {/* --- RIGHT PANEL --- */}
          <div className="right-panel" style={styles.rightPanel}>
            {isMobile && (
              <div style={{
                ...landingPageStyles.header,
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                backgroundColor: '#ffffff',
                zIndex: 10,
              }}>
                <div style={landingPageStyles.logoContainer}>
                  <img src={nimg1} alt="Logo" style={landingPageStyles.logoIcon} />
                </div>
                <div style={landingPageStyles.logoContainer}>
                  <img src={nimg2} alt="Logo" style={landingPageStyles.logoIcon} />
                </div>
              </div>
            )}
            {isMobile && (
              <div style={styles.mobileTopImageWrapper}>
                <img src={lpnm1} alt="Accident help" style={styles.mobileTopImage} />
              </div>
            )}
            <FormWrapper isMobile={isMobile} mobileFormCardStyle={styles.mobileFormCard}>
              <div style={styles.stepIndicator}>
                {isMobile ? (
                  <>
                    {step === 1 ? (
                      <button
                        type="button"
                        className="btn-back"
                        onClick={() => setShowLandingPage(true)}
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '8px',
                          backgroundColor: 'transparent',
                          border: 'none',
                          color: '#1a237e',
                          cursor: 'pointer',
                          fontSize: '0.85rem',
                          fontWeight: 600,
                          padding: '0',
                          transition: 'color 0.3s'
                        }}
                      >
                        <i className="fa-solid fa-arrow-left"></i>
                        <span>Back</span>
                      </button>
                    ) : step > 1 ? (
                      <button
                        type="button"
                        className="btn-back"
                        onClick={handlePrevious}
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '8px',
                          backgroundColor: 'transparent',
                          border: 'none',
                          color: '#1a237e',
                          cursor: 'pointer',
                          fontSize: '0.85rem',
                          fontWeight: 600,
                          padding: '0',
                          transition: 'color 0.3s'
                        }}
                      >
                        <i className="fa-solid fa-arrow-left"></i>
                        <span>Back</span>
                      </button>
                    ) : (
                      <span></span>
                    )}
                    <span style={styles.stepCount}>
                      <span style={{color: '#546e7a'}}>Step <span style={{color: '#e64a19'}}>{step}</span>/3</span>
                    </span>
                  </>
                ) : (
                  <>
                    {step >= 1 ? (
                      <button
                        type="button"
                        className="btn-back"
                        onClick={handlePrevious}
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '8px',
                          backgroundColor: 'transparent',
                          border: 'none',
                          color: '#1a237e',
                          cursor: 'pointer',
                          fontSize: '0.9rem',
                          fontWeight: 600,
                          padding: '0',
                          transition: 'color 0.3s'
                        }}
                      >
                        <i className="fa-solid fa-arrow-left"></i>
                        <span>Back</span>
                      </button>
                    ) : (
                      <span></span>
                    )}
                    <span style={{display: 'flex', alignItems: 'center', gap: '4px'}}>
                      <span>Step</span>
                      <span style={styles.stepCount}>
                        <span style={{color: '#e64a19'}}>{step}</span>/2
                      </span>
                    </span>
                  </>
                )}
              </div>

            {/* STEP 1 */}
            {step === 1 && (
              <div className="step-1-container" style={styles.stepContainer}>
                <div style={styles.formGroup}>
                  <label style={styles.formLabel}>Were you involved in an accident?</label>
                  <div className="radio-options" style={styles.radioOptions}>
                    <div className="radio-option" style={styles.radioOption} onClick={() => handleRadioChange('involved', 'yes')}>
                      <input 
                        type="radio" 
                        id="involved-yes" 
                        name="involved" 
                        checked={formData.involved === 'yes'}
                        onChange={() => handleRadioChange('involved', 'yes')}
                      />
                      <label htmlFor="involved-yes">Yes</label>
                    </div>
                    <div className="radio-option" style={styles.radioOption} onClick={() => handleRadioChange('involved', 'no')}>
                      <input 
                        type="radio" 
                        id="involved-no" 
                        name="involved" 
                        checked={formData.involved === 'no'}
                        onChange={() => handleRadioChange('involved', 'no')}
                      />
                      <label htmlFor="involved-no">No</label>
                    </div>
                  </div>
                </div>

                <div style={styles.formGroup}>
                  <label style={styles.formLabel}>Were you injured?</label>
                  <div className="radio-options" style={styles.radioOptions}>
                    <div className="radio-option" style={styles.radioOption} onClick={() => handleRadioChange('injured', 'yes')}>
                      <input 
                        type="radio" 
                        id="injured-yes" 
                        name="injured" 
                        checked={formData.injured === 'yes'}
                        onChange={() => handleRadioChange('injured', 'yes')}
                      />
                      <label htmlFor="injured-yes">Yes</label>
                    </div>
                    <div className="radio-option" style={styles.radioOption} onClick={() => handleRadioChange('injured', 'no')}>
                      <input 
                        type="radio" 
                        id="injured-no" 
                        name="injured" 
                        checked={formData.injured === 'no'}
                        onChange={() => handleRadioChange('injured', 'no')}
                      />
                      <label htmlFor="injured-no">No</label>
                    </div>
                  </div>
                </div>

                <div style={styles.formGroup}>
                  <label style={styles.formLabel}>Were you legally at fault?</label>
                  <div className="radio-options" style={styles.radioOptions}>
                    <div className="radio-option" style={styles.radioOption} onClick={() => handleRadioChange('fault', 'yes')}>
                      <input 
                        type="radio" 
                        id="fault-yes" 
                        name="fault" 
                        checked={formData.fault === 'yes'}
                        onChange={() => handleRadioChange('fault', 'yes')}
                      />
                      <label htmlFor="fault-yes">Yes</label>
                    </div>
                    <div className="radio-option" style={styles.radioOption} onClick={() => handleRadioChange('fault', 'no')}>
                      <input 
                        type="radio" 
                        id="fault-no" 
                        name="fault" 
                        checked={formData.fault === 'no'}
                        onChange={() => handleRadioChange('fault', 'no')}
                      />
                      <label htmlFor="fault-no">No</label>
                    </div>
                  </div>
                </div>

                {/* Desktop: Show all questions in step 1 */}
                {!isMobile && (
                  <>
                    <div style={styles.formGroup}>
                      <label style={styles.formLabel}>Do you already have an attorney?</label>
                      <div className="radio-options" style={styles.radioOptions}>
                        <div className="radio-option" style={styles.radioOption} onClick={() => handleRadioChange('attorney', 'yes')}>
                          <input 
                            type="radio" 
                            id="attorney-yes-desktop" 
                            name="attorney-desktop"
                            checked={formData.attorney === 'yes'}
                            onChange={() => handleRadioChange('attorney', 'yes')}
                          />
                          <label htmlFor="attorney-yes-desktop">Yes</label>
                        </div>
                        <div className="radio-option" style={styles.radioOption} onClick={() => handleRadioChange('attorney', 'no')}>
                          <input 
                            type="radio" 
                            id="attorney-no-desktop" 
                            name="attorney-desktop"
                            checked={formData.attorney === 'no'}
                            onChange={() => handleRadioChange('attorney', 'no')}
                          />
                          <label htmlFor="attorney-no-desktop">No</label>
                        </div>
                      </div>
                    </div>

                    <div style={styles.formGroup}>
                      <label style={styles.formLabel}>When did the accident happen?</label>
                      <div style={styles.customSelectWrapper} ref={dropdownRef}>
                        <div style={styles.customSelectTrigger} onClick={toggleDropdown}>
                          <span>{period || 'Select timeframe'}</span>
                          <div style={styles.triggerArrow}>
                            <i className="fa-solid fa-chevron-down" style={{color: 'white', fontSize: '0.7rem'}}></i>
                          </div>
                        </div>
                        <div style={styles.customOptions} className="custom-options">
                          {['In last 1 month', 'In last 3 months', 'In last 6 months', 'In last 1 year'].map((opt) => (
                            <div 
                              key={opt}
                              className={`custom-option ${period === opt ? 'selected' : ''}`}
                              onClick={() => selectOption(opt)}
                            >
                              <div className="radio-circle"></div>
                              <span>{opt}</span>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </>
                )}

                <div style={{marginTop: 'auto', paddingTop: isMobile ? '10px' : '20px', paddingBottom: isMobile ? '20px' : '0', width: '100%', maxWidth: '100%', boxSizing: 'border-box'}}>
                  <button type="button" className="btn-primary" style={styles.btnPrimary} onClick={handleNext}>
                    Next <i className="fa-solid fa-arrow-right"></i>
                  </button>
                </div>
              </div>
            )}

            {/* STEP 2 - Mobile only: Attorney and Period questions */}
            {step === 2 && isMobile && (
              <div className="step-2-container" style={styles.stepContainer}>
                <div style={styles.formGroup}>
                  <label style={styles.formLabel}>Do you already have an attorney?</label>
                  <div className="radio-options" style={styles.radioOptions}>
                    <div className="radio-option" style={styles.radioOption} onClick={() => handleRadioChange('attorney', 'yes')}>
                      <input 
                        type="radio" 
                        id="attorney-yes-mobile" 
                        name="attorney-mobile"
                        checked={formData.attorney === 'yes'}
                        onChange={() => handleRadioChange('attorney', 'yes')}
                      />
                      <label htmlFor="attorney-yes-mobile">Yes</label>
                    </div>
                    <div className="radio-option" style={styles.radioOption} onClick={() => handleRadioChange('attorney', 'no')}>
                      <input 
                        type="radio" 
                        id="attorney-no-mobile" 
                        name="attorney-mobile"
                        checked={formData.attorney === 'no'}
                        onChange={() => handleRadioChange('attorney', 'no')}
                      />
                      <label htmlFor="attorney-no-mobile">No</label>
                    </div>
                  </div>
                </div>

                <div style={styles.formGroup}>
                  <label style={styles.formLabel}>When did the accident happen?</label>
                  <div style={styles.customSelectWrapper} ref={dropdownRef}>
                    <div style={styles.customSelectTrigger} onClick={toggleDropdown}>
                      <span>{period || 'Select timeframe'}</span>
                      <div style={styles.triggerArrow}>
                        <i className="fa-solid fa-chevron-down" style={{color: 'white', fontSize: '0.7rem'}}></i>
                      </div>
                    </div>
                    <div style={styles.customOptions} className="custom-options">
                      {['In last 1 month', 'In last 3 months', 'In last 6 months', 'In last 1 year'].map((opt) => (
                        <div 
                          key={opt}
                          className={`custom-option ${period === opt ? 'selected' : ''}`}
                          onClick={() => selectOption(opt)}
                        >
                          <div className="radio-circle"></div>
                          <span>{opt}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>

                <div style={{marginTop: 'auto', paddingTop: isMobile ? '10px' : '20px', paddingBottom: isMobile ? '20px' : '0', width: '100%', maxWidth: '100%', boxSizing: 'border-box'}}>
                  <button type="button" className="btn-primary" style={styles.btnPrimary} onClick={handleNext}>
                    Next <i className="fa-solid fa-arrow-right"></i>
                  </button>
                </div>
              </div>
            )}

            {/* STEP 2 - Desktop: Contact form, OR STEP 3 - Mobile: Contact form */}
            {((step === 2 && !isMobile) || (step === 3 && isMobile)) && !(step === 2 && isMobile) && (
              <div className="step-2-container fade-in" style={{...styles.stepContainer, animation: 'fadeIn 0.5s'}}>
                <div style={styles.step2Header}>Share Your Information to Get Started</div>
                {!isMobile && <div style={styles.step2Subheader}>You may be entitled to settlement.</div>}

                <div style={styles.formGroup}>
                  <input 
                    type="text" 
                    className="form-input" 
                    style={errors.name ? styles.formInputError : styles.formInput} 
                    placeholder={isMobile ? "Your Name" : "Your Name"} 
                    value={formData.name}
                    onChange={(e) => handleInputChange('name', e.target.value)}
                    onBlur={(e) => {
                      const error = validateName(e.target.value);
                      setErrors(prev => ({ ...prev, name: error }));
                    }}
                  />
                  {errors.name && <span style={styles.errorMessage}>{errors.name}</span>}
                </div>

                <div style={styles.formGroup}>
                  <input 
                    type="tel" 
                    className="form-input" 
                    style={errors.phone ? styles.formInputError : styles.formInput} 
                    placeholder={isMobile ? "Phone Number" : "Phone Number"} 
                    value={formData.phone}
                    onChange={(e) => {
                      handleInputChange('phone', e.target.value);
                    }}
                    onBlur={(e) => {
                      const error = validatePhone(e.target.value);
                      setErrors(prev => ({ ...prev, phone: error }));
                    }}
                    inputMode="numeric"
                  />
                  {errors.phone && <span style={styles.errorMessage}>{errors.phone}</span>}
                </div>

                <div style={styles.formGroup}>
                  <input 
                    type="email" 
                    className="form-input" 
                    style={errors.email ? styles.formInputError : styles.formInput} 
                    placeholder={isMobile ? "Email Address" : "Email Address"} 
                    value={formData.email}
                    onChange={(e) => {
                      handleInputChange('email', e.target.value);
                      triggerEmailUpdate(e.target.value);
                    }}
                    onBlur={(e) => {
                      const error = validateEmail(e.target.value);
                      setErrors(prev => ({ ...prev, email: error }));
                    }}
                  />
                  {errors.email && <span style={styles.errorMessage}>{errors.email}</span>}
                </div>

                <div style={styles.checkboxGroup}>
                  <input 
                    type="checkbox" 
                    id="terms" 
                    checked={formData.terms}
                    onChange={(e) => handleCheckboxChange(e.target.checked)}
                    style={{marginTop: '4px', accentColor: '#1a237e', minWidth: '16px', minHeight: '16px'}} 
                  />
                  <label htmlFor="terms" style={styles.legalText}>
                    I agree to the <a href="/PrivacyPolicy" target="_blank" rel="noopener noreferrer" style={{color: '#162766', fontWeight: 700, textDecoration: 'underline', cursor: 'pointer'}}>Privacy policy</a> and <a href="/Disclaimer" target="_blank" rel="noopener noreferrer" style={{color: '#162766', fontWeight: 700, textDecoration: 'underline', cursor: 'pointer'}}>Disclaimer</a> and give my express written consent, affiliates and/or lawyer to contact you at the number provided above, even if this number is a wireless number or if I am presently listed on a Do Not Call list. I understand that I may be contacted by telephone, email, text message or mail regarding case options and that I may be called using automatic dialing equipment. Message and data rates may apply. My consent does not require purchase. This is Legal advertising.
                  </label>
                </div>

                <div style={styles.buttonContainer}>
                  {!isMobile && step !== 2 && (
                    <button type="button" className="btn-primary" style={styles.btnPrevious} onClick={handlePrevious} disabled={isSubmitting}>
                      <i className="fa-solid fa-arrow-left"></i> Previous
                    </button>
                  )}
                  <button 
                    type={!isMobile && step === 2 ? "submit" : "button"} 
                    className="btn-primary" 
                    style={{...styles.btnSubmit, opacity: isSubmitting ? 0.6 : 1, cursor: isSubmitting ? 'not-allowed' : 'pointer', width: isMobile ? '100%' : (!isMobile && step === 2 ? '100%' : 'auto'), maxWidth: '100%', flex: isMobile ? 'none' : (!isMobile && step === 2 ? 'none' : 1), boxSizing: 'border-box'}} 
                    onClick={handleSubmit}
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? (
                      <>
                        <i className="fa-solid fa-spinner fa-spin"></i> Submitting...
                      </>
                    ) : (
                      <>
                        {isMobile ? 'Submit Now' : 'Submit Now'} <i className="fa-solid fa-arrow-right"></i>
                      </>
                    )}
                  </button>
                </div>
              </div>
            )}

            </FormWrapper>
          </div>
        </div>
      )}
    </div>
  );
};

export default ClaimForm3;
